import {actions} from './actions'

const initialState = {}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.PUT:
      return {
        ...state,
        [action.device]: action.state
      }
    case actions.REMOVE:
      delete state[action.device]
      return state
    case actions.SET:
      return action.devices
    default:
      return state
  }
}

export default reducer
